import React, {Component} from 'react';
import * as logo from "../../static/logo.png";
import {Layout} from "antd/lib/index";
import {connect} from "react-redux";
import {Link, withRouter} from "react-router-dom";
import {Icon, Menu} from "antd";
import PropTypes from 'prop-types';
import Auth from "../../util/auth";

const { Header, Content, Footer } = Layout;

class AppLayout extends Component {

    static propTypes = {
        loggedIn: PropTypes.bool,
        dispatch: PropTypes.func,
        location: PropTypes.any
    }

    logout = () => {
        this.props.dispatch({type: 'LOGOUT'});
        const authInst = Auth.getInstance();
        authInst._setToken(authInst._getEmptyToken());
        window.location.reload();
    }

    render() {
        return (
            <Layout className="layout">
                <Header>
                    <div className="logo">
                        <img src={logo} alt="SO Logo"/>
                    </div>
                    <Menu
                        theme="dark"
                        mode="horizontal"
                        defaultSelectedKeys={[this.props.location.pathname]}
                        style={{ lineHeight: '64px' }}
                    >
                        <Menu.Item key="/">
                            <Link to="/">Meldingen</Link>
                        </Menu.Item>
                        <Menu.Item key="/benchmark">
                            <Link to="/benchmark">Benchmark</Link>
                        </Menu.Item>
                        <Menu.Item key="/jaaroverzicht">
                            <Link to="/jaaroverzicht">Jaaroverzicht</Link>
                        </Menu.Item>
                        {/*
                        <Menu.Item key="/storingen">
                            <Link to="/storingen">Storingen</Link>
                        </Menu.Item>
                        <Menu.SubMenu title="Gegevens">
                            <Menu.ItemGroup title="Basisgegevens">
                                <Menu.Item key="/locaties">
                                    <Link to="/locaties">Locaties</Link>
                                </Menu.Item>
                                <Menu.Item key="/loggers">
                                    <Link to="/loggers">Loggers</Link>
                                </Menu.Item>
                                <Menu.Item key="/omvormers">
                                    <Link to="/omvormers">Omvormers</Link>
                                </Menu.Item>
                            </Menu.ItemGroup>
                            <Menu.ItemGroup title="Wizard">
                                <Menu.Item key="/wizard">
                                    <Link to="/wizard">Nieuwe Locatie</Link>
                                </Menu.Item>
                            </Menu.ItemGroup>
                        </Menu.SubMenu>
                        */}
                        <Menu.SubMenu title={<span><Icon type="user"/>{this.props.user.name}</span>} style={{float: 'right'}}>
                            <Menu.Item key="profile:1"><a onClick={this.logout}> Uitloggen</a></Menu.Item>
                        </Menu.SubMenu>
                    </Menu>
                </Header>
                <Content style={{ padding: '0 50px' }}>
                    <div style={{ background: '#fff', padding: 24, minHeight: 280 }}>
                        {this.props.children}
                    </div>
                </Content>
                <Footer style={{ textAlign: 'center' }}>
                    Slim Opgewekt © {(new Date()).getFullYear()}
                </Footer>
            </Layout>
        )
    }
}


const mapStateToProps = state => {
    return {
        user: state.user,
        dispatch: state.dispatch
    }
};

export default withRouter(connect(mapStateToProps)(AppLayout));



// WEBPACK FOOTER //
// ./src/components/shared/applayout.js